import "./App.css";

import React, { Component, useEffect } from 'react'
import RoutesApp from "./routes/index.js";
import { AuthProvider } from "./contexts/auth";
import { ThemeProvider } from '@mui/material/styles';
import { themeOptions } from "./assets/themeOptions";
import "react-activity/dist/Digital.css";
import CssBaseline from "@mui/material/CssBaseline";
import Cookies from 'js-cookie';

class RootErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error('[RootErrorBoundary] crash:', error?.toString());
        console.error('[RootErrorBoundary] stack:', info?.componentStack);
    }

    handleGoToLogin() {
        Cookies.remove('airton@data');
        window.location.href = '/login';
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    minHeight: '100vh',
                    background: '#0F1117',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontFamily: 'sans-serif',
                    padding: '2rem',
                    color: '#fff',
                    textAlign: 'center',
                }}>
                    <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>⚠️</div>
                    <h2 style={{ color: '#FF6B35', marginBottom: '0.5rem' }}>Qualcosa è andato storto</h2>
                    <p style={{ color: '#A0A8C0', marginBottom: '1.5rem', fontSize: '0.9rem', maxWidth: 500 }}>
                        {this.state.error?.toString()}
                    </p>
                    <button
                        onClick={this.handleGoToLogin}
                        style={{
                            background: 'linear-gradient(135deg, #701280, #8E3A9E)',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '12px 28px',
                            fontSize: '1rem',
                            fontWeight: 600,
                            cursor: 'pointer',
                        }}
                    >
                        Torna al Login
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        console.log(`Version: ${process.env.REACT_APP_VERSION_APP}`)
    }, []);

    return (
        <RootErrorBoundary>
            <AuthProvider>
                <ThemeProvider theme={themeOptions}>
                    <CssBaseline />
                    <RoutesApp />
                </ThemeProvider>
            </AuthProvider>
        </RootErrorBoundary>
    );
}

export default App;
